export enum GroupReadjustmentQuoeficient {
    IgpDiFgv = 1,
    IgpMFgv = 2,
    Ipc = 3,
    Inpc = 4,
    Ipca = 5,
    Aditivo = 6,
    NotApplicable = 7
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/readjustmentQuoeficient.enum.ts